var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"g-catalogo-filters"},[_c('catalogue-mobile-filters'),_vm._v(" "),_c('catalogue-desktop-filters'),_vm._v(" "),_c('catalogue-sort')],1)}
var staticRenderFns = []

export { render, staticRenderFns }